import { Component, OnDestroy, OnInit } from '@angular/core';
import { fadeIn } from '../../../../../animations/form-error';
import { BasePageComponent } from '../../../../base-page';
import { ICountry } from '../../../../../model/country.model';
import { Subject } from 'rxjs';
import { CountryService } from '../../../countries/countries.service';
import { MatDialogRef } from '@angular/material/dialog';
import { FormService } from '../../../../../shared/services/form.service';
import { AccRessTypeColumnName } from '../../../acc-ress-type/acc-ress-type-column-name';
import { UntypedFormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../../interfaces/app-state';
import { HttpService } from '../../../../../services/http/http.service';
import { takeUntil } from 'rxjs/operators';
import { ValidatorService } from '../validator.service';
import { ValidatorColumnName } from '../validator-column-name';
import { Validators as ValidatorsModel } from '../../../../../model/champs_formulaire/validators.model';
import { BaseService } from '../../../base/base.service';

/**
 * Permet de gérer la suppression d'un country
 */
@Component({
  selector: 'app-validator-delete',
  templateUrl: './validator-delete.component.html',
  animations: [fadeIn]
})
export class ValidatorDeleteComponent extends BasePageComponent
  implements OnInit, OnDestroy {
  countrySelected: ValidatorsModel;
  private subs$ = new Subject<void>();
  isDeleting = false;
  successDelete = false;
  serverHasError = false;
  hasDelete = false;

  constructor(
    private baseService: BaseService,
    private countryService: ValidatorService,
    private dialogRef: MatDialogRef<ValidatorDeleteComponent>,
    private formService: FormService,
    private columnName: ValidatorColumnName,
    private fb: UntypedFormBuilder,
    store: Store<IAppState>, httpSv: HttpService) {
    super(store, httpSv);
    console.log('## construct validator delete');
  }

  ngOnInit(): void {
    console.log('## init validator delete.');
    this.countryService.getObjetSelectObs()
      .pipe(takeUntil(this.subs$)).subscribe((res) => {
      console.log('## get validator selected');
      try {
        console.log('## data: ', res);
        this.countrySelected = res;
      } catch (e) {
        console.log('## error get validator delete: ' + e.message);
      }
      super.setLoaded();
    });
  }

  ngOnDestroy() {
    console.log('## destroy validator delete');
    this.formService.free(this.subs$);
    this.countryService.setObjetSelectObs(undefined);
  }

  closeModal() {
    console.log('## close delete validator');
    this.dialogRef.close();
  }

  delete() {
    console.log('## deleting validator');
    this.isDeleting = true;
    this.serverHasError = false;
    this.successDelete = false;
    this.countryService.delete(this.countrySelected.id,
      this.countryService.resourceUrl).subscribe(
      response => {
        console.log('## success delete country');
        this.serverHasError = false;
        this.successDelete = true;
        this.isDeleting = false;
        this.hasDelete = true;
        this.responseFromServer();
        this.countryService.getAllObjet();
      }, error => {
        console.log('## error delete country');
        this.serverHasError = true;
        this.successDelete = false;
        this.isDeleting = false;
        this.responseFromServer();
      });
  }

  private responseFromServer() {
    setTimeout(() => {
      this.isDeleting = false;
    }, 300);
  }
}
